import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxState } from "..";
import {
    createTagRegexesTransaction,
    createTagRegexesSet,
    createTagRegexWithSet,
    getTaxRegexesByType,
    updateTagRegexesTransaction,
} from "../../docuclipper/api";
import {
    TagTransactionRule,
    TagRegexes,
    TagRegexesSets,
    TagRegexesType,
} from "../../docuclipper/DocuclipperTypes";
import { createAlert } from "./Alerts";
import { deleteTagRegexes } from '../../docuclipper/api';

const initialState: {
    loading: boolean;
    tagRegexesTransaction: TagRegexes[];
    TagRegexesTransactionSets: TagRegexesSets[];
} = {
    loading: false,
    tagRegexesTransaction: [],
    TagRegexesTransactionSets: [],
};

const slice = createSlice({
    name: "TagRegexesTransaction",
    initialState,
    reducers: {
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },

        updateTagRegexesTransaction2(state, action: PayloadAction<{ id; jsonRules }>) {
            state.tagRegexesTransaction = state.tagRegexesTransaction.map((x) =>
                x.id === action.payload.id
                    ? { ...x, jsonRules: action.payload.jsonRules }
                    : x
            );
        },
        addTagRegexesTransaction(state, action: PayloadAction<TagRegexes>) {
            state.tagRegexesTransaction = [...state.tagRegexesTransaction, action.payload];
        },
        addTagRegexesTransactionSet(state, action: PayloadAction<TagRegexesSets>) {
            state.TagRegexesTransactionSets = [...state.TagRegexesTransactionSets, action.payload];
        },
        setTagRegexesTransaction(state, action: PayloadAction<TagRegexes[]>) {
            state.tagRegexesTransaction = action.payload;
        },
        setTagRegexesTransactionSets(state, action: PayloadAction<TagRegexesSets[]>) {
            state.TagRegexesTransactionSets = action.payload;
        },
    },
});

export const {
    setLoading,
    updateTagRegexesTransaction2,
    setTagRegexesTransaction,
    setTagRegexesTransactionSets,
    addTagRegexesTransaction,
    addTagRegexesTransactionSet,
} = slice.actions;

export const fetchTagRegexesTransaction = (type: TagRegexesType, integrationId: number | null) => async (dispatch, getState) => {
    const state: ReduxState = getState();
    if (state.TagRegexesTransaction.loading) {
        return;
    }
    dispatch(setLoading(true));

    try {
        const {
            tagRegexes: tagRegexesTransaction,
            tagRegexesSets: tagRegexesTransactionSets
        } = await getTaxRegexesByType(type, integrationId, "invoice"); // using "invoice" as placeholder

        dispatch(setTagRegexesTransaction(tagRegexesTransaction));
        dispatch(setTagRegexesTransactionSets(tagRegexesTransactionSets));
        dispatch(setLoading(false));
    } catch (err) {
        dispatch(setLoading(false));
    }
};

export const updateTagRegexesTransactionAction =
    (id, rule, integrationId) => async (dispatch, getState) => {
        try {
            updateTagRegexesTransaction(id, rule)
                .then((res) => {
                    dispatch(updateTagRegexesTransaction2({ id, jsonRules: res.jsonRules }));
                    dispatch(
                        createAlert({
                            message: "Transaction rules updated successfully",
                            timeout: 3000,
                            type: "success",
                        })
                    );
                })
                .catch((err) => dispatch(createAlert({
                    message: err.message || "Error updating transaction rules. Please try again.",
                    timeout: 0,
                    type: "error",
                })));
        } catch (err) { }
    };

export const deleteTagRegexesTransactionAction = (id, integrationId) => async (dispatch, getState) => {
    try {
        const state: ReduxState = getState()
        deleteTagRegexes(id)
            .then(() => {
                dispatch(
                    createAlert({
                        message: "Transaction Rule deleted successfully",
                        timeout: 3000,
                        type: "success",
                    })
                );

                dispatch(setTagRegexesTransaction(state.TagRegexesTransaction.tagRegexesTransaction.filter((x) => x.id !== id)));
                dispatch(setTagRegexesTransactionSets(state.TagRegexesTransaction.TagRegexesTransactionSets.filter((x) => x.tagRegexesId !== id)));
            })
            .catch((err) => dispatch(createAlert({
                message: err.message || "Error deleting transaction rule. Please try again.",
                timeout: 0,
                type: "error",
            })));
    } catch (err) { }
}

export const addNewTransactionGroup = (name, rule: TagTransactionRule, integrationId) => async (dispatch, getState) => {
    if (!name) {
        dispatch(
            createAlert({
                message: "Need to specify the transaction group name",
                timeout: 0,
                type: "error",
            })
        );
        return;
    }
    try {
        createTagRegexWithSet(name, `${rule.tag}`, "", "[]", rule, "transactionRules")
            .then((rsp) => {
                dispatch(
                    addTagRegexesTransaction({
                        id: rsp.tagRegex.id,
                        regexes: rsp.tagRegex.regexes,
                        tag: rsp.tagRegex.tag,
                        jsonRules: JSON.parse(rsp.tagRegex.jsonRules)
                    })
                );
                dispatch(addTagRegexesTransactionSet(rsp.tagRegexSet));
            })
            .catch((err) => dispatch(createAlert({
                message: err.message || "Error creating transaction group. Please try again.",
                timeout: 0,
                type: "error",
            })));
    } catch (err) { }
};

export default slice.reducer; 